export enum AmrDealTabTypes {
    details = 'details',
    classes = 'classes',
    documents = 'documents'
}
